import React from "react";
import { useNavigate } from "react-router-dom";

const formatLabel = (key) => {
  return key
    .replace(/([A-Z])/g, ' $1')
    .replace(/^./, str => str.toUpperCase());
};

const formatValue = (key, value) => {
  if (key === 'alertRecieved' && typeof value === 'number') {
    return new Date(value).toLocaleString('en-US', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      hour: 'numeric',
      minute: '2-digit',
      hour12: true
    });
  }
  return value;
};

const SOSAlertPopup = ({ sosAlert, isOpen, onClose, onTakeAction }) => {
  const navigate = useNavigate();
  
  if (!isOpen || !sosAlert) return null;

  const handleActionClick = () => {
    navigate(`/complaints/detail`, { state: {id: sosAlert?.ticketUUID, name: sosAlert?.ticketId, demandProfileId:sosAlert?.customerId}});
    onTakeAction();
  }

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[1300] p-4">
      <div className="bg-white rounded-[10px] shadow-2xl w-full max-w-l lg:max-w-xl overflow-hidden mx-4">
        {/* Header */}
        <div className="bg-[#FF6969] text-white px-6 py-12 text-center">
          <h2 className="text-2xl font-bold mb-1">Emergency Alert</h2>
          <p className="text-lg">Immediate Response Required</p>
        </div>
        {/* Content */}
        <div className="p-6 bg-gray-50">
          <div className="bg-[#F2F2F2] rounded-lg p-4 space-y-4">
            {Object.entries(sosAlert).map(([key, value]) => (
              <>
              {(key !== "ticketUUID" && key !== "customerId" && key !== "isB2B") && <div key={key} className="flex items-start gap-x-8">
                <span className="text-[#666] text-sm w-32 flex-shrink-0">{formatLabel(key)}</span>
                <span className="flex-1 text-black text-sm">
                  {formatValue(key, value)}
                </span>
              </div>}
              </>
            ))}
          </div>
          {/* Action Button */}
          <div className="mt-6 flex justify-end">
            <button
              onClick={handleActionClick}
              className="bg-[#CF0000] text-white px-6 py-2 rounded text-sm font-medium hover:bg-red-700 transition-colors"
            >
              Take Action
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SOSAlertPopup;